import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import FixturesList from './components/FixturesList'
import LeagueTable from './components/LeagueTable'

export default function Fixtures() {
  return (
    <div className="relative min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col overflow-hidden">

      {/* Watermark */}
      <div
        className="absolute inset-0 bg-top bg-no-repeat bg-contain opacity-[0.08] dark:opacity-[0.06] pointer-events-none"
        style={{ backgroundImage: "url('/images/dsms_watermark.png')" }}
      />

      <Navbar />
      <div className="relative z-10 flex-1 px-4 sm:px-6 lg:px-8 py-6 lg:py-10 max-w-6xl mx-auto w-full">
        <div className="mb-6 lg:mb-10">
          <h1 className="text-2xl lg:text-4xl font-black uppercase tracking-tight mb-2">
            Fixtures & Results
          </h1>
          <p className="text-gray-500 text-sm">
            Match schedule, results and league standings
          </p>
        </div>
        <LeagueTable />
        <FixturesList />
      </div>
      <Footer />
    </div>
  )
}